import { render, staticRenderFns } from "./FooterPart.vue?vue&type=template&id=1b0cc271&scoped=true&"
import script from "./FooterPart.vue?vue&type=script&lang=js&"
export * from "./FooterPart.vue?vue&type=script&lang=js&"
import style0 from "./FooterPart.vue?vue&type=style&index=0&id=1b0cc271&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0cc271",
  null
  
)

export default component.exports